import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
// import "./ProjectsFilterSection.scss";
import styles from "./ProjectsFilterSection.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProjects } from "../../reducer/projectsSlice";
import FormInput from "../FormInput/FormInput";
import { getCategories } from "../../reducer/profileSlice";
import SelectCustom from "components/common/Select/Select";
import { SelectStyles } from "utils/constants";
import { selectMapper } from "utils/utils";
import SearchIconSVG from "components/SVGComponents/SearchIconSVG";
import SearchSVG from "components/SVGComponents/SearchSVG";
import FilterIconSVG from "components/SVGComponents/FilterIconSVG";
import CrossIconSVG from "components/SVGComponents/CrossIconSVG";
import Modal from "components/Modal/Modal";
import { useDisclosure } from "hooks";
import Button from "components/UI/Button/Button";
import CustomSortDropdown from "components/CustomSortDropdown/CustomSortDropdown";

const defaultValues = {
  search: "",
  categoryName: "",
  skills: "",
  location: "",
  preference: "",
  industry: "",
};

const ProjectsFilterSection = ({ pages, itemsPerPage, sortBy, setSortBy }) => {
  const dispatch = useDispatch();
  // const locationUse = useLocation();
  const {
    isOpen: filterModalOpen,
    open: openfilterModal,
    close: closefilterModal,
  } = useDisclosure();

  const { categories } = useSelector((state) => state.userProfile);

  const newCategories = selectMapper(categories);

  const navigate = useNavigate();
  const {
    register,
    control,
    reset,
    watch,
    formState: { errors },
  } = useForm({ defaultValues });

  const [hasInteracted, setHasInteracted] = useState(false);

  const search = watch("search");
  const categoryName = watch("categoryName");
  const skills = watch("skills");
  const location = watch("location");
  const industry = watch("industry");
  const preference = watch("preference");

  const isAnyFilterActive =
    !!search ||
    !!categoryName ||
    !!skills?.length ||
    !!location ||
    !!industry ||
    !!preference;

  // console.log(industry);
  // console.log(preference);

  const [isDesktop, setIsDesktop] = useState(false);
  const [isfilterModalOpen, setIsfilterModalOpen] = useState(false);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    if (
      search ||
      categoryName ||
      skills ||
      location ||
      industry ||
      preference
    ) {
      setHasInteracted(true);
    }
  }, [search, categoryName, skills, location, industry, preference]);

  useEffect(() => {
    if (!hasInteracted || !isDesktop) return;

    // const params = new URLSearchParams();
    const payload = {
      pageNo: 1,
      perPage: itemsPerPage,
      sortBy: sortBy.toUpperCase(),
    };

    const setParam = (key, value) => {
      if (value?.trim?.() || typeof value === "number") {
        // params.set(key, value);
        payload[key] = value;
      }
    };

    setParam("search", search);
    setParam("categoryName", categoryName);
    setParam("skills", skills);
    setParam("location", location);
    setParam("industry", industry);

    if (preference?.value) {
      const id = parseInt(preference.value);
      setParam("categoryId", id);
      payload.categoryId = id;
    }

    const timer = setTimeout(() => {
      // navigate(`?${params.toString()}`, { replace: true });
      dispatch(getProjects(payload));
    }, 300);

    return () => clearTimeout(timer);
  }, [
    search,
    skills,
    industry,
    location,
    preference,
    navigate,
    dispatch,
    hasInteracted,
    itemsPerPage,
  ]);

  const applyFilters = () => {
    if (!hasInteracted) return;

    const payload = {
      pageNo: 1,
      perPage: itemsPerPage,
      sortBy: sortBy.toUpperCase(),
    };

    const setParam = (key, value) => {
      if (value?.trim?.() || typeof value === "number") {
        payload[key] = value;
      }
    };

    setParam("search", watch("search"));
    setParam("categoryName", watch("categoryName"));
    setParam("skills", watch("skills"));
    setParam("location", watch("location"));
    setParam("industry", watch("industry"));

    if (watch("preference")?.value) {
      const id = parseInt(watch("preference").value);
      payload.categoryId = id;
    }

    setHasInteracted(true);

    dispatch(getProjects(payload));
    closefilterModal();
  };

  const clearFilters = () => {
    if (!hasInteracted) return;

    reset(defaultValues);
    setHasInteracted(false);
    navigate("?", { replace: true }); // 🧹 Clear query params
    dispatch(
      getProjects({ pageNo: 1, perPage: itemsPerPage, sortBy: "LATEST" }),
    );
    closefilterModal();
  };

  useEffect(() => {
    const checkScreenSize = () => setIsDesktop(window.innerWidth > 1024);
    checkScreenSize(); // Run on mount
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  return (
    <section className={styles.projectsFilterSection}>
      {isDesktop && (
        <section className={styles.projectsFilterSearch}>
          <p>Keyword Search</p>
          <input
            autoComplete="off"
            type="text"
            placeholder="Search projects"
            {...register("search")}
          />
        </section>
      )}
      {!isDesktop && (
        <div className={styles.filter_project_container}>
          <section
            className={styles.projectsFilterSearch}
            // style={{ width: "25em" }}
          >
            <SearchSVG />
            <input
              autoComplete="off"
              type="text"
              placeholder="Search projects"
              {...register("search")}
              style={{
                outline: "none",
                background: "transparent",
                border: "none",
              }}
            />
            <button className={styles.filtericonsvg} onClick={openfilterModal}>
              {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#7E7E7E"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-funnel-icon lucide-funnel"
              >
                <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
              </svg> */}
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4 7H20"
                  stroke="#7E7E7E"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7 12L17 12"
                  stroke="#7E7E7E"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11 17H13"
                  stroke="#7E7E7E"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            {/* <CustomSortDropdown
              isMobileView={true}
              value={sortBy}
              // setValue={updateSortBy}
              setValue={setSortBy}
              options={["Latest", "Oldest"]}
              // defaultValue="Latest"
            /> */}
          </section>
          <section className={styles.projectsFilterSort}>
            {/* <button className={styles.filtericonsvg} onClick={openfilterModal}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#7E7E7E"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-funnel-icon lucide-funnel"
              >
                <path d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
              </svg>
            </button> */}
            <CustomSortDropdown
              isMobileView={true}
              value={sortBy}
              // setValue={updateSortBy}
              setValue={setSortBy}
              options={["Latest", "Oldest"]}
              // defaultValue="Latest"
            />
          </section>
        </div>
      )}

      <div></div>
      {isDesktop && (
        <section className={styles.projectsFilterAllFilters}>
          <section className={styles.allFiltersHeading}>
            <p>Filter</p>
            {hasInteracted && <button onClick={clearFilters}>Clear All</button>}
          </section>

          <section className={styles.allFiltersInputs}>
            <div className={styles.filterInputSection}>
              {/* <label className="filter_labels">Category</label> */}
              {/* <input
              autoComplete="off"  
              className="filter_input"
              type="text"
              placeholder="e.g. Production House"
              {...register("categoryName")}
            /> */}

              <FormInput
                label="Work Title"
                register={register}
                id="industry"
                type="text"
                placeholder="e.g Photographer, Writer, Designer"
                error={errors.industry}
              />
            </div>

            {/* <div className="filter-input-section">
            <FormInput
              label="Preference"
              register={register}
              id="preference"
              type="select_2"
              // required
              options={categories}
              validation={{ required: "Preference is Required" }}
              error={errors.preference}
            />s
          </div> */}

            <div className={styles.reactSelect}>
              <label htmlFor="">Preferences</label>
              <Controller
                name="preference" // Use consistent naming (lowercase)
                control={control}
                rules={{ required: "Mandatory Field" }} // Optional validation
                render={({ field }) => (
                  <SelectCustom
                    {...field}
                    // isMulti={true}
                    placeholder="Select preference"
                    options={newCategories}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                    }}
                    styles={SelectStyles}
                    searchable={true}
                  />
                )}
              />
            </div>

            <div className={styles.filterInputSection}>
              {/* <label className="filter_labels">Skills</label>
            <input
              autoComplete="off"
              className="filter_input"
              type="text"
              placeholder="e.g. Photoshop"
              {...register("skills")}
            /> */}

              <FormInput
                label="Skills"
                register={register}
                id="skills"
                type="text"
                placeholder="e.g Adobe, Figma, Photoshop"
                error={errors.skills}
              />
            </div>
            <div className={styles.filterInputSection}>
              {/* <label className="filter_labels">Location</label>
            <input
              autoComplete="off"
              className="filter_input"
              type="text"
              placeholder="e.g. Mumbai"
              {...register("location")}
            /> */}
              <FormInput
                label="Location"
                register={register}
                id="location"
                type="text"
                placeholder="e.g Mumbai, Delhi, Bangalore"
                error={errors.location}
              />
            </div>
          </section>
        </section>
      )}

      {!isDesktop && (
        <Modal
          background="white"
          modalOpen={filterModalOpen}
          onClose={closefilterModal}
          width="20rem"
          drawer={{
            isDrawer: true,
          }}
        >
          <section className={styles.filterContainer}>
            <section className={styles.filterbutton}>
              <p>Filter</p>
              {hasInteracted && (
                // <button onClick={clearFilters}>Clear All</button>
                <span onClick={closefilterModal}>
                  <CrossIconSVG color="#6570fc" />
                </span>
              )}
            </section>

            <section className={styles.filterallFiltersInputs}>
              <div className={styles.filterInputSection}>
                <FormInput
                  label="Industry"
                  register={register}
                  id="industry"
                  type="text"
                  placeholder="Industry"
                  error={errors.industry}
                />
                <button
                  className={styles.addButton}
                  type="button"
                  onClick={() => {}}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 12H19"
                      stroke="#AEB2E3"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 5V19"
                      stroke="#AEB2E3"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              {/* <div className="filter-input-section">
            <FormInput
              label="Preference"
              register={register}
              id="preference"
              type="select_2"
              // required
              options={categories}
              validation={{ required: "Preference is Required" }}
              error={errors.preference}
            />
          </div> */}

              <div className={styles.reactSelect}>
                <label htmlFor="">Preferences</label>
                <Controller
                  name="preference" // Use consistent naming (lowercase)
                  control={control}
                  rules={{ required: "Mandatory Field" }} // Optional validation
                  render={({ field }) => (
                    <SelectCustom
                      {...field}
                      placeholder="Select Preference"
                      options={newCategories}
                      onChange={(selectedOption) => {
                        field.onChange(selectedOption);
                      }}
                      styles={SelectStyles}
                      searchable={true}
                    />
                  )}
                />
              </div>

              <div className={styles.filterInputSection}>
                {/* <label className="filter_labels">Skills</label>
            <input
              autoComplete="off"
              className="filter_input"
              type="text"
              placeholder="e.g. Photoshop"
              {...register("skills")}
            /> */}

                <FormInput
                  label="Skills"
                  register={register}
                  id="skills"
                  type="text"
                  placeholder="e.g Adobe, Figma, Photoshop"
                  error={errors.skills}
                />
              </div>
              <div className={styles.filterInputSection}>
                {/* <label className="filter_labels">Location</label>
            <input
              autoComplete="off"
              className="filter_input"
              type="text"
              placeholder="e.g. Mumbai"
              {...register("location")}
            /> */}
                <FormInput
                  label="Location"
                  register={register}
                  id="location"
                  type="text"
                  placeholder="e.g Mumbai, Delhi, Bangalore"
                  error={errors.location}
                />
              </div>

              <div className={styles.formBtns}>
                <Button
                  onClick={clearFilters}
                  className={styles.btn}
                  variant="outlined"
                >
                  Clear All
                </Button>
                <Button
                  onClick={applyFilters}
                  className={styles.btn}
                  variant="filled"
                >
                  Filter
                </Button>
              </div>
            </section>
          </section>
        </Modal>
      )}

      {/* <section className="allFilters-checkboxes">
          <Controller
            name="budget"
            control={control}
            render={({ field }) => (
              <BudgetSlider
                budget={field.value}
                onBudgetChange={field.onChange}
              />
            )}
          />
        </section> */}
    </section>
  );
};

export default ProjectsFilterSection;
